import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseAddCategoryComponent } from "../utils/types";

const useAddCategoryComponent = (): IUseAddCategoryComponent =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.post("v1/create-category-component", data);
      return response.data;
    },
  });

export default useAddCategoryComponent;
